<template>
  <div class="main-content">
    <div class="main-content-heading">
      <h1>Online spätná väzba formulár</h1>
      <div class="back">
        <a @click="$router.go(-1)">&lt; Späť</a>
      </div>
    </div>
    <div class="heading-spliter"></div>
    <div class="text-mute">
      Pomocou osobnostných a psychodiagnostických dotazníkov pomôžeme odhaliť silné a slabé stránky jednotlivcov.
      Dokážeme identifikovať typ osobnosti jednotlivca a popísať jeho charakteristiky, čo mu umožní lepšie
      porozumieť svojím preferencíám a preferenciám ostatných.
    </div>
    <div class="persons-content">
      <!--- HEADER -->
      <div class="feedback-group-wrapper">
        <div class="feedback-group-inner border-bottom header">
          <div>
            <span class="text-mute">NÁZOV:</span>
            <span class="text-main">{{name}}</span>
          </div>
          <div  v-if="!is_active">
            <span class="text-mute">STAV:</span>
            <span class="text-red">
              <span v-if="is_active">Prebiehajúci</span>
              <span v-if="!is_active">Pred spustením</span>
            </span>
          </div>
          <div v-if="is_active">
            <div class="d-flex a-items-center">
              <div>
                <span class="text-mute">Dokončené:</span>
                <span class="text-red">{{completionRate}}%</span>
              </div>
              <div class="progress-bar m-l-50">
                  <div class="line" v-bind:style="{ width: Math.round(240 * completionRate / 100) + 'px' }"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="feedback-group-inner flex-row">
          <div>
            <span class="text-mute">DÁTUM ZAČIATKU:</span>
            <span class="text-main">{{date_start}}</span>
          </div>

          <div>
            <span class="text-mute">DÁTUM KONCA:</span>
            <span class="text-main">{{date_end}}</span>
          </div>

          <div>
            <span class="text-mute">JAZYK KURZU:</span>
            <span class="text-main">{{lang}}</span>
          </div>
        </div>
      </div>
      <!--- END HEADER -->

      <div class="notification-box d-flex a-items-center">
        <div  v-if="is_active" class="text-mute m-r-40">
          Ak je vyplnenosť prieskumu nízka vzhľadom k blížiacemu sa ukončeniu Vášho prieskumu, môžete požiadať o e-mailovú notifikáciu tých účastníkov prieskumu,
          ktorí ho ešte nemali možnosť vyplniť kliknutím na tlačidlo Notifikovať. Ostatné nechajte na nás :)
        </div>
        <div class="right" v-if="is_active">
            <button class="button" type="button" @click="notify">Notifikovať Maxman</button>
        </div>
      </div>

      <!--- PARTICIPANTS -->
      <FeedbackEditParticipants
        :is_active="is_active"
        :is_editing_participants="is_editing_participants"
        :courseId="courseId"
      />
      <!--- END PARTICIPANTS -->

      <!--- RELATIONS -->
      <FeedbackEditRelations
        :is_active="is_active"
        :is_editing_participants="is_editing_participants"
        :courseId="courseId"
      />
      <!--- END RELATIONS -->

      <!--- AREAS -->
      <div class="">
        <h2>Oblasti prieskumu</h2>
        <div class="areas">
          <div class="area-item" v-for="(area, aidx) in areas" v-bind:key="area.id">
            <div class="area-header">
              <span>{{aidx+1}}. {{area.name}}</span>
              <span class="text-red inline" @click="toggleOpenArea(area.id)">
                {{!openAreas[area.id] ? "Zobraziť otázky" : "Skryť otázky"}}
                <span
                  v-bind:class="[!openAreas[area.id] ? 'ico-caret-down-red' : 'ico-caret-up-red']"
                ></span>
              </span>
            </div>
            <div class="area-questions" v-if="!!openAreas[area.id]">
              <div
                class="area-question-item"
                v-for="(question, qidx) in area.question"
                :key="question.id"
              >
                <span>{{qidx+1}}. {{question.text}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--- END AREAS -->

      <!--- SCALE -->
      <div v-if="scale">
        <h2 class="">Škála prieskumu</h2>
        <div class="scale-listing">
          <div v-for="level in scale.scale_levels" :key="level.id" class="scale-item">
            <div class="item-circle">o</div>
            <div>{{level.text}}</div>
          </div>
        </div>
      </div>
      <!--- END SCALE -->
    </div>
  </div>
</template>
<style lang="css">
  .persons-content {
    margin-top: 2rem;
  }
  .item-circle{
    text-align: center;
    font-size: 13pt;
    line-height: 18pt;
    color: #777;
  }

  .scale-listing {
    padding: 28px;
    background: #FFF;
    border: 1px solid #eeeeee;;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .scale-item {
    color: #b11116;
  }
</style>


<script>
import FormBase from "../../elements/FormBase";
import FeedbackEditParticipants from "./FeedbackEditParticipants";
import FeedbackEditRelations from "./FeedbackEditRelations";
import { mapState } from "vuex";

export default {
  props: ["courseId"],
  components: { FeedbackEditParticipants, FeedbackEditRelations },
  mixins: [FormBase],
  data() {
    return {
      is_editing_participants: false,
      openAreas: {}
    };
  },
  mounted() {},
  created() {
    this.refresh();
  },
  methods: {
    refresh() {
      this.$store.commit("feedback/setCourseId", { courseId: this.courseId});
      this.$store.commit("feedback/setLangId", { langId: this.$api.translator.getCurrent() });
      this.$store.dispatch("feedback/loadFeedback");
    },
    toggleOpenArea(areaId) {
      this.openAreas = { ...this.openAreas, [areaId]: !this.openAreas[areaId] };
    },
    notify(){
      this.$api.server.post("api/public/company/feedback/notify/" + this.courseId).then((r) => {
           });
    }
  },
  computed: {
    ...mapState({
      is_active: state => state.feedback.isActive,
      name: state => state.feedback.name,
      date_start: state => state.feedback.dateStart,
      date_end: state => state.feedback.dateEnd,
      lang: state => state.feedback.lang,
      areas: state => state.feedback.areas,
      scale: state => state.feedback.scale,
      completionRate: state => state.feedback.completionRate,
    })
  },
  watch: {},
  validations() {}
};
</script>



// WEBPACK FOOTER //
// src/public_app/pages/feedback/FeedbackEdit.vue